import { tokens } from '@/styles/tokens';
import { alpha, Box, Divider, styled, TextField, Typography } from '@mui/material';

// Bottom Floating Navigation
export const PageNavigationContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'offsetPx',
})<{ offsetPx: number }>(({ offsetPx }) => ({
  position: 'absolute',
  bottom: 24,
  left: '50%',
  // The host decides how far to shift the bar (the editor pushes it clear of its open
  // drawer); `0` renders identically to a plain `translateX(-50%)`.
  transform: `translateX(calc(-50% - ${offsetPx / 2}px))`,
  zIndex: 10,
  transition: 'transform 225ms cubic-bezier(0, 0, 0.2, 1)',
}));

export const BottomNavigation = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  backgroundColor: '#fff',
  border: `1px solid ${tokens.grey[90]}`,
  borderRadius: 12,
  padding: 4,
  height: 40,
  boxShadow: '0px 5px 20px rgba(0, 62, 71, 0.05)',
});

export const PageInputWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
});

export const PageInput = styled(TextField)({
  width: 32,
  '& .MuiOutlinedInput-root': {
    height: 32,
    borderRadius: 8,
    backgroundColor: alpha(tokens.grey[100], 0.5),
    border: `2px solid transparent`,
    '& fieldset': {
      border: `1px solid transparent`,
    },
    '& input': {
      padding: 0,
      textAlign: 'center',
      fontSize: 14,
      fontWeight: 500,
      color: tokens.grey[0],
    },
  },
});

export const PageDivider = styled(Typography)({
  fontSize: 12,
  fontWeight: 600,
  color: tokens.grey[50],
});

export const TotalPages = styled(Typography)({
  fontSize: 12,
  fontWeight: 600,
  color: tokens.grey[0],
});

export const NavDivider = styled(Divider)({
  height: 16,
  margin: 'auto',
});
